module.exports = __webpack_public_path__ + "assets/img/Arty_Digital_cover.00cae8b6-ps.jpg";